import './ChatMessage.less';
import type { ChatMessage as ChatMessageModel } from '../../models/ChatMessage';
import UserChatMessage from './UserChatMessage';
import AssistantChatMessage from './AssistantChatMessage';

export type ChatMessageProps = {
    chatMessage: ChatMessageModel;
};

const ChatMessage = ({ chatMessage }: ChatMessageProps) => (
    <div className={`bri-ChatMessage bri-ZoomIn`}>
        {chatMessage.role === 'user' && (
            <UserChatMessage userChatMessage={chatMessage} />
        )}
        {chatMessage.role === 'assistant' && (
            <AssistantChatMessage assistantChatMessage={chatMessage} />
        )}
    </div>
);

export default ChatMessage;
